import { Component, OnInit, ViewEncapsulation, ViewChild, ElementRef, AfterViewInit, HostListener } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { environment } from './../../../environments/environment';
import { DefaultService } from '@psnb/psnb-api';
@Component({
  selector: 'nwt-power-supply-nav-bar',
  templateUrl: './power-supply-nav-bar.component.html',
  styleUrls: ['./power-supply-nav-bar.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PowerSupplyNavBarComponent {
  /*Function to navigate the home page  */
  disableLink: boolean = false;
  title: string = "Power Supply Notebook - TEST";
  env: string = environment.env;

  constructor(private router: Router,private powerSupplyService: DefaultService,) {
    if (this.router.url.includes('unauthorized')) {
      this.disableLink = true;
    }

    if (environment.env == 'prod') {
      this.title = "Power Supply Notebook";
    }
  }
  ngOnInit() {
    this.powerSupplyService.getAllPsEditFieldsMetadata()
    .subscribe(Psresult => {
      localStorage.removeItem('AllPsEditFieldsMetadata');
      localStorage.setItem('AllPsEditFieldsMetadata',JSON.stringify(Psresult));

    });
  }

  /*Function to navigate the home page  */
  onClickSearchPS() {
    if (!this.disableLink) {
      this.router.navigate(['']);
    }
  }
}
